import { useRTL } from '@hooks/useRTL';
import { Row, Col } from 'reactstrap';
import ApexAreaCharts from './components/ApexAreaCharts';
import ApexRadialBarChart from './components/ApexRadialbar';
import ApexColumnChart from './components/ApexColumnCharts';
import StatsComponent from './components/StatsComponent';
import Stats2Component from './components/Stats2Component';
import Stats3Component from './components/Stats3Component';
import ClientsCharts from './components/ClientsCharts';
import FilterComponents from './components/FilterComponents';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { DASHBOARD_QUERY } from '../../../graphql/Query/dashboard';
import Spinner from '../../../@core/components/spinner/Fallback-spinner';
import { useState } from 'react';

const AnalyticsDashboard = () => {
  const [isRtl] = useRTL();
  const [picker, setPicker] = useState([
    moment().subtract(30, 'days').toDate(),
    moment().toDate()
  ]);
  const { data, loading, error } = useQuery(DASHBOARD_QUERY, {
    variables: {
      input: {
        initDate: moment(picker[0]).format('YYYY-MM-DD'),
        endDate: moment(picker[1]).format('YYYY-MM-DD')
      }
    }
  });
  const [currentGender, setCurrentGender] = useState({
    value: 'EMPTY',
    label: 'Seleccionar Género'
  });

  if (loading) {
    return <Spinner />;
  }
  if (error) {
    return <Spinner />;
  }

  if (!data) {
    return <Spinner />;
  }

  const { getDashboard: _data } = data;

  return (
    <div id="dashboard-analytics">
      <Row className="match-height">
        <Col xl="12">
          <FilterComponents
            setCurrentGender={setCurrentGender}
            currentGender={currentGender}
            setPicker={setPicker}
            picker={picker}
          />
        </Col>
        <Col xl="12" lg="12">
          <StatsComponent data={_data.stats} />
        </Col>
        <Col xl="12" lg="12" className={'mb-2'}>
          <Stats2Component data={_data.stats2} />
        </Col>
        <Col xl="4" lg="12">
          <ClientsCharts data={_data.stats3} />
        </Col>
        <Col xl="4" lg="12">
          <ApexRadialBarChart data={_data.stats4} />
        </Col>
        <Col lg="12" xs="12">
          <ApexAreaCharts
            data={_data.stats3.session}
            direction={isRtl ? 'rtl' : 'ltr'}
          />
        </Col>

        {/*<Col xl="8" lg="12">
          <ApexColumnChart
            data={_data.stats4.dailyRegister}
            direction={isRtl ? 'rtl' : 'ltr'}
          />
        </Col>*/}
        <Col xl="6" lg="12">
          <Stats3Component
            data={_data.stats5.totalRoadsByPillars}
            title="Caminos por Pilar"
          />
        </Col>
        <Col xl="6" lg="12">
          <Stats3Component
            data={_data.stats5.totalRoadsLikesByPillars}
            title="Me Gusta por Pilar"
          />
        </Col>
      </Row>
    </div>
  );
};

export default AnalyticsDashboard;
